// Shared icons for the WO document cards (technical documents, proposals,
// invoices). Kept in one place so the three cards stay visually consistent.

export const ChevronIcon = ({ expanded }) => (
  <svg
    className={`w-4 h-4 text-[#7C829A] transition-transform duration-200 ${expanded ? "" : "rotate-180"}`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 12.5L10 7.5L15 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PdfFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M0 2.5C0 1.12109 1.12109 0 2.5 0H8.75V5C8.75 5.69141 9.30859 6.25 10 6.25H15V11.875H6.875C5.49609 11.875 4.375 12.9961 4.375 14.375V20H2.5C1.12109 20 0 18.8789 0 17.5V2.5ZM15 5H10V0L15 5ZM6.875 13.75H8.125C9.33203 13.75 10.3125 14.7305 10.3125 15.9375C10.3125 17.1445 9.33203 18.125 8.125 18.125H7.5V19.375C7.5 19.7188 7.21875 20 6.875 20C6.53125 20 6.25 19.7188 6.25 19.375V17.5V14.375C6.25 14.0312 6.53125 13.75 6.875 13.75ZM8.125 16.875C8.64453 16.875 9.0625 16.457 9.0625 15.9375C9.0625 15.418 8.64453 15 8.125 15H7.5V16.875H8.125ZM11.875 13.75H13.125C14.1602 13.75 15 14.5898 15 15.625V18.125C15 19.1602 14.1602 20 13.125 20H11.875C11.5312 20 11.25 19.7188 11.25 19.375V14.375C11.25 14.0312 11.5312 13.75 11.875 13.75ZM13.125 18.75C13.4688 18.75 13.75 18.4688 13.75 18.125V15.625C13.75 15.2812 13.4688 15 13.125 15H12.5V18.75H13.125ZM16.25 14.375C16.25 14.0312 16.5312 13.75 16.875 13.75H18.75C19.0938 13.75 19.375 14.0312 19.375 14.375C19.375 14.7188 19.0938 15 18.75 15H17.5V16.25H18.75C19.0938 16.25 19.375 16.5312 19.375 16.875C19.375 17.2188 19.0938 17.5 18.75 17.5H17.5V19.375C17.5 19.7188 17.2188 20 16.875 20C16.5312 20 16.25 19.7188 16.25 19.375V16.875V14.375Z"
      fill="#EF4444"
    />
  </svg>
);

export const ExcelFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M0 2.5C0 1.12109 1.12109 0 2.5 0H8.75V5C8.75 5.69141 9.30859 6.25 10 6.25H15V17.5C15 18.8789 13.8789 20 12.5 20H2.5C1.12109 20 0 18.8789 0 17.5V2.5ZM15 5H10V0L15 5Z"
      fill="#16A34A"
    />
    <rect x="3.75" y="9.5" width="7.5" height="6" rx="0.75" stroke="white" strokeWidth="1.1" />
    <path d="M3.75 12.5H11.25M7.5 9.5V15.5" stroke="white" strokeWidth="1.1" />
  </svg>
);

export const DownloadMenuIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 8.5V0.5C6 0.223858 6.22386 0 6.5 0C6.77614 0 7 0.223858 7 0.5V8.5C7 8.77614 6.77614 9 6.5 9C6.22386 9 6 8.77614 6 8.5Z"
      fill="#7C829A"
    />
    <path
      d="M0 11.1667V8.5C0 8.22386 0.223858 8 0.5 8C0.776143 8 1 8.22386 1 8.5V11.1667C1 11.3877 1.08786 11.5996 1.24414 11.7559C1.40042 11.9121 1.61232 12 1.83333 12H11.1667C11.3877 12 11.5996 11.9121 11.7559 11.7559C11.9121 11.5996 12 11.3877 12 11.1667V8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5V11.1667C13 11.6529 12.8067 12.1191 12.4629 12.4629C12.1191 12.8067 11.6529 13 11.1667 13H1.83333C1.3471 13 0.880926 12.8067 0.537109 12.4629C0.193293 12.1191 0 11.6529 0 11.1667Z"
      fill="#7C829A"
    />
    <path
      d="M9.47982 4.81315C9.67508 4.61789 9.99159 4.61789 10.1869 4.81315C10.3821 5.00841 10.3821 5.32492 10.1869 5.52018L6.85352 8.85352C6.65825 9.04878 6.34175 9.04878 6.14649 8.85352L2.81315 5.52018C2.61789 5.32492 2.61789 5.00841 2.81315 4.81315C3.00841 4.61789 3.32492 4.61789 3.52018 4.81315L6.5 7.79297L9.47982 4.81315Z"
      fill="#7C829A"
    />
  </svg>
);

// Open padlock: unlocks a submitted form for the technicians to edit again.
export const ReopenMenuIcon = ({ color = "#7C829A" }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="7" width="11" height="7.5" rx="1.5" stroke={color} />
    <path
      d="M5 7V4.5C5 2.84315 6.34315 1.5 8 1.5C9.30622 1.5 10.4175 2.33481 10.8293 3.5"
      stroke={color}
      strokeLinecap="round"
    />
    <path d="M8 10V11.5" stroke={color} strokeLinecap="round" />
  </svg>
);

export const EditMenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.0004 12.8334C14.2765 12.8334 14.5004 13.0573 14.5004 13.3334C14.5004 13.6095 14.2765 13.8334 14.0004 13.8334H8.00035C7.72421 13.8334 7.50035 13.6095 7.50035 13.3334C7.50035 13.0573 7.72421 12.8334 8.00035 12.8334H14.0004Z"
      fill="#1A2332"
    />
    <path
      d="M12.8337 3.41561C12.8337 3.17294 12.737 2.94009 12.5655 2.76847C12.3938 2.59685 12.1611 2.50024 11.9183 2.50024C11.6756 2.50025 11.4428 2.59685 11.2712 2.76847L3.26404 10.7756C3.16498 10.8746 3.09236 10.9973 3.0531 11.1318L2.57914 12.7542L4.20219 12.2808C4.3367 12.2416 4.45989 12.169 4.55896 12.0699L12.5655 4.06274C12.737 3.89117 12.8336 3.65825 12.8337 3.41561ZM13.8337 3.41561C13.8336 3.92346 13.6316 4.41066 13.2725 4.76978L5.26599 12.7769C5.04793 12.995 4.77821 13.1542 4.48214 13.2405L2.56743 13.7991C2.42411 13.8408 2.27193 13.8439 2.12732 13.8069C1.98271 13.7698 1.85075 13.6943 1.74516 13.5888C1.63952 13.4832 1.56414 13.3507 1.52706 13.206C1.49005 13.0613 1.49242 12.9092 1.53422 12.7659L2.09282 10.8512C2.17918 10.5554 2.33909 10.2864 2.55701 10.0686L10.5642 2.06144C10.9233 1.70228 11.4104 1.50025 11.9183 1.50024C12.4263 1.50024 12.9133 1.70228 13.2725 2.06144C13.6316 2.42059 13.8337 2.90772 13.8337 3.41561Z"
      fill="#1A2332"
    />
    <path
      d="M9.64684 2.97988C9.8421 2.78462 10.1586 2.78462 10.3539 2.97988L12.3539 4.97989C12.5491 5.17515 12.5491 5.49165 12.3539 5.68692C12.1586 5.88218 11.8421 5.88218 11.6468 5.68692L9.64684 3.68692C9.45157 3.49165 9.45157 3.17515 9.64684 2.97988Z"
      fill="#1A2332"
    />
  </svg>
);

export const DeleteMenuIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 3.49992C14.2761 3.49992 14.5 3.72378 14.5 3.99992C14.5 4.27606 14.2761 4.49992 14 4.49992H2C1.72386 4.49992 1.5 4.27606 1.5 3.99992C1.5 3.72378 1.72386 3.49992 2 3.49992H14Z"
      fill="#EF4444"
    />
    <path
      d="M2.83333 13.3333V3.99992C2.83333 3.72378 3.05719 3.49992 3.33333 3.49992C3.60948 3.49992 3.83333 3.72378 3.83333 3.99992V13.3333C3.83333 13.504 3.92369 13.7166 4.10352 13.8964C4.28334 14.0762 4.49595 14.1666 4.66667 14.1666H11.3333C11.5041 14.1666 11.7167 14.0762 11.8965 13.8964C12.0763 13.7166 12.1667 13.504 12.1667 13.3333V3.99992C12.1667 3.72378 12.3905 3.49992 12.6667 3.49992C12.9428 3.49992 13.1667 3.72378 13.1667 3.99992V13.3333C13.1667 13.8292 12.9237 14.2833 12.6035 14.6034C12.2833 14.9236 11.8293 15.1666 11.3333 15.1666H4.66667C4.17072 15.1666 3.71666 14.9236 3.39648 14.6034C3.07631 14.2833 2.83333 13.8292 2.83333 13.3333Z"
      fill="#EF4444"
    />
    <path
      d="M10.1667 3.99992V2.66659C10.1667 2.49587 10.0763 2.28326 9.89649 2.10343C9.71666 1.92361 9.50405 1.83325 9.33333 1.83325H6.66667C6.49595 1.83325 6.28334 1.92361 6.10352 2.10343C5.92369 2.28326 5.83333 2.49587 5.83333 2.66659V3.99992C5.83333 4.27606 5.60948 4.49992 5.33333 4.49992C5.05719 4.49992 4.83333 4.27606 4.83333 3.99992V2.66659C4.83333 2.17064 5.07631 1.71658 5.39649 1.3964C5.71666 1.07623 6.17072 0.833252 6.66667 0.833252H9.33333C9.82928 0.833252 10.2833 1.07623 10.6035 1.3964C10.9237 1.71658 11.1667 2.17064 11.1667 2.66659V3.99992C11.1667 4.27606 10.9428 4.49992 10.6667 4.49992C10.3905 4.49992 10.1667 4.27606 10.1667 3.99992Z"
      fill="#EF4444"
    />
    <path
      d="M6.16667 11.3333V7.33325C6.16667 7.05711 6.39053 6.83325 6.66667 6.83325C6.94281 6.83325 7.16667 7.05711 7.16667 7.33325V11.3333C7.16667 11.6094 6.94281 11.8333 6.66667 11.8333C6.39053 11.8333 6.16667 11.6094 6.16667 11.3333Z"
      fill="#EF4444"
    />
    <path
      d="M8.83333 11.3333V7.33325C8.83333 7.05711 9.05719 6.83325 9.33333 6.83325C9.60948 6.83325 9.83334 7.05711 9.83334 7.33325V11.3333C9.83334 11.6094 9.60948 11.8333 9.33333 11.8333C9.05719 11.8333 8.83333 11.6094 8.83333 11.3333Z"
      fill="#EF4444"
    />
  </svg>
);
